import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

const opacityAnimation = keyframes`
 0%, 100% { opacity: 1 }
 50% { opacity: .4 }
`;

const S = {
  LoaderAnimation: styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    animation: ${opacityAnimation} 4s infinite;
  `,
  LoaderContainer: styled.div`
    padding-top: ${tokens.spacer.x2};
    padding-left: ${tokens.spacer.x2};
    padding: ${tokens.spacer.x2};
    background: ${tokens.color.neutral_100};
    margin-bottom: ${tokens.spacer.x2};
    border-radius: ${tokens.radius.m};
  `,
  Base: styled.div`
    background: ${tokens.color.neutral_200};
    height: 100%;
  `,
  Row: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
  `,
};

function SkeletonTableRow(): JSX.Element {
  return (
    <S.Row style={{ marginBottom: tokens.spacer.x2, height: '25px' }}>
      <S.Base style={{ width: '50px', marginRight: tokens.spacer.x3 }} />
      <S.Base style={{ width: '30%', marginRight: '20%' }} />
      <S.Base style={{ width: '50px', marginRight: tokens.spacer.x3 }} />
      <S.Base style={{ width: '50px', marginRight: 'auto' }} />
      <S.Base style={{ width: '100px', marginRight: tokens.spacer.x3 }} />
      <S.Base style={{ width: '25px', marginRight: tokens.spacer.x2 }} />
      <S.Base style={{ width: '25px', marginRight: tokens.spacer.x2 }} />
      <S.Base style={{ width: '25px', marginRight: tokens.spacer.x2 }} />
    </S.Row>
  );
}

export const TeamListPageLoader = (): JSX.Element => (
  <S.LoaderContainer data-testid="team-list-page-loader">
    <S.LoaderAnimation>
      <S.Row style={{ marginBottom: tokens.spacer.x4, height: '50px' }}>
        <S.Base style={{ width: '50px', marginRight: tokens.spacer.x3 }} />
        <S.Base style={{ height: '50%', flexBasis: '30%' }} />
        <S.Base style={{ marginLeft: 'auto', width: '25px', height: '50%' }} />
      </S.Row>

      <S.Row
        style={{
          paddingBottom: tokens.spacer.x2,
          marginBottom: tokens.spacer.x2,
          borderBottom: `1px solid ${tokens.color.neutral_300}`,
          height: '35px',
        }}
      >
        <S.Base style={{ width: '50px', marginRight: tokens.spacer.x3 }} />
        <S.Base style={{ width: '20%', marginRight: '30%' }} />
        <S.Base style={{ width: '50px', marginRight: tokens.spacer.x3 }} />
        <S.Base style={{ width: '50px', marginRight: tokens.spacer.x3 }} />
      </S.Row>
      <SkeletonTableRow />
      <SkeletonTableRow />
    </S.LoaderAnimation>
  </S.LoaderContainer>
);
